import { render, staticRenderFns } from "./PredictionScore.vue?vue&type=template&id=16ba551e&"
import script from "./PredictionScore.vue?vue&type=script&lang=ts&"
export * from "./PredictionScore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports